import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=1ad7ca50&scoped=true&"
import script from "./EventsList.vue?vue&type=script&lang=ts&"
export * from "./EventsList.vue?vue&type=script&lang=ts&"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=1ad7ca50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7ca50",
  null
  
)

export default component.exports